import type { ChartConfig } from '@/components/ui/chart';

export const TOTAL_CARDS = 6;

export const DUAA_TEXT =
  'اللهم أعني على ذكرك، وشكرك، وحسن عبادتك';

export const DUAA_MEANING =
  'โอ้อัลลอฮ์ โปรดช่วยเหลือข้าพระองค์ให้รำลึกถึงพระองค์ ขอบคุณพระองค์ และเคารพภักดี (อิบาดะฮ์) ต่อพระองค์เป็นอย่างดีด้วยเถิด';

export const chartConfig: ChartConfig = {
  pages: {
    label: 'หน้าที่อ่าน',
    color: 'var(--chart-1)',
  },
};

/** Padding ข้างบน/ซ้ายขวา — padding ล่างใช้ SLIDE_SCROLL_BOTTOM_PAD (เว้นแถบ fixed) */
export const SLIDE_PADDING =
  'px-4 pt-[max(1rem,env(safe-area-inset-top))] sm:px-6 sm:pt-6 md:px-8';

/** การ์ดเต็มความสูงพื้นที่สไลด์ (100dvh) — scroll ภายใน + เว้นที่แถบ fixed ล่าง */
export const SLIDE_CARD =
  'rounded-none border-0 shadow-none flex h-full min-h-0 w-full max-w-lg flex-col overflow-hidden mx-auto sm:max-w-none';

/** พื้นหลังการ์ดโปร่งใสเข้ากับผิวกระดาษ */
export const STORY_CARD_BG =
  'bg-transparent before:pointer-events-none before:absolute before:inset-0 before:bg-[radial-gradient(ellipse_80%_50%_at_50%_0%,hsl(var(--primary)/0.06),transparent_60%)]';

/** padding ล่างเนื้อหา = เว้นให้เลขหน้า */
export const SLIDE_SCROLL_BOTTOM_PAD =
  'pb-[calc(2.5rem+env(safe-area-inset-bottom,0px))] sm:pb-[calc(3rem+env(safe-area-inset-bottom,0px))]';

/** ข้อความเล่าเรื่อง — เส้นทางการเดินทางเป้าหมาย */
export const NARRATIVE = {
  celebration: {
    wrapUp: 'ทุกหน้าที่อ่านมีค่ายิ่ง — มาดูเส้นทางที่คุณเดินมาด้วยกัน',
    complete: 'คุณเดินทางมาถึงแล้ว — มาดูสรุปเส้นทางของเป้าหมายนี้กัน',
  },
  goalSummary: 'นี่คือจุดเริ่มต้นของเส้นทาง — เป้าหมายที่คุณตั้งไว้และความคืบหน้าที่ทำได้',
  readingDays: 'แต่ละวันที่เปิดอ่านคือก้าวหนึ่งบนเส้นทาง — ปฏิทินความดีตลอดช่วงเป้าหมาย',
  streak: 'ความต่อเนื่องคือพลัง — วันที่อ่านติดกันยาวนานที่สุดในเส้นทางนี้',
  dailyChart: 'ทุกวันมีเรื่องเล่า — จำนวนหน้าที่อ่านในแต่ละวันตลอดเส้นทาง',
  closing: 'สรุปเส้นทางทั้งหมด — ทุกสถิติของการเดินทางสู่เป้าหมายนี้',
} as const;
